import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import get from "lodash/get";
import CreatePostIcon from "../../assets/images/feed/create/post.svg";
import ReviewIcon from "../../assets/images/feed/create/review.svg";
import CreateCollabIcon from "../../assets/images/feed/create/collaboration.svg";
import CreateSurveyIcon from "../../assets/images/feed/create/survey.svg";
import CreateQuizIcon from "../../assets/images/feed/create/quiz.svg";
import CreatePollIcon from "../../assets/images/feed/create/poll.svg";
import CreatePost from "./CreatePost";
import CreatePoll from "./CreatePoll";
import Avatar from "../user/Avatar";
import ReviewCreateButton from "../premium/ReviewCreateButton";

const CreateBar = (props) => {
  const {
    user: {
      premiumCompanies,
      user: { profile },
    },
    handleOpen,
    handleButtonClick
  } = props;
  const [type, setType] = useState(null);

  const showReview = Boolean((profile && profile.is_premium) || (premiumCompanies && premiumCompanies.companies && premiumCompanies.companies.length));

  const handleUpdate = (type = null) => {
    if (type) {
      document.body.style.overflow = "hidden";
      setType(type);
      handleOpen(true);
      return;
    }
    document.body.style.overflow = "auto";
    setType(null);
    handleOpen(false);
  };

  const handleSurveyOrPollClose = () => {
    handleUpdate();
  };

  return (
    <div className="post-bar__container">
      {!!premiumCompanies.hasFetched && (
        <>
          <div className="post-bar">
            <div
              onClick={() => handleUpdate("post")}
              className={`post-bar__btn post-bar__btn--no-text ${type === "post" ? "post-bar__btn--active" : ""
                }`}
            >
              <img src={CreatePostIcon} alt="create post" />
            </div>

            {showReview && (
              <ReviewCreateButton classNameToAppend="post-bar__btn" handleButtonClick={handleButtonClick}>
                <img
                  className="post-bar__btn__icon"
                  src={ReviewIcon}
                  alt="create review"
                />
                <span className="post-bar__btn__text">Review</span>
              </ReviewCreateButton>
            )}

            <button
              onClick={() => { handleButtonClick("collaboration") }}
              className="post-bar__btn"
            >
              <img
                className="post-bar__btn__icon"
                src={CreateCollabIcon}
                alt="create collaboration"
              />
              <span className="post-bar__btn__text">Collaborate</span>
            </button>

            <button
              onClick={() => { handleButtonClick("poll") }}
              className="post-bar__btn"
            >
              <img
                className="post-bar__btn__icon"
                src={CreatePollIcon}
                alt="create poll"
              />
              <span className="post-bar__btn__text">Poll</span>
            </button>

            <button
              onClick={() => { handleButtonClick("survey") }}
              className="post-bar__btn"
            >
              <img
                className="post-bar__btn__icon"
                src={CreateSurveyIcon}
                alt="create survey"
              />
              <span className="post-bar__btn__text">Survey</span>
            </button>
            <button
              onClick={() => { handleButtonClick("quiz") }}
              className="post-bar__btn"
            >
              <img
                className="post-bar__btn__icon"
                src={CreateQuizIcon}
                alt="create quiz"
              />
              <span className="post-bar__btn__text">Quiz</span>
            </button>
          </div>

          {type && (
            <div className="post-bar__create-modal">
              {type === "post" && (
                <CreatePost handleClose={() => handleUpdate()} />
              )}
              {type === "poll" && (
                <CreatePoll handleClose={handleSurveyOrPollClose} />
              )}
            </div>
          )}

          {!type && profile ? (
            <div
              onClick={() => handleUpdate("post")}
              className="post-bar__post post-bar__post--blank"
            >
              <div className="post-bar__post__arrow"></div>
              <div className="user-create-block">
                <Avatar
                  alt={get(profile, "name", "")}
                  className="user-create-block__avatar"
                  src={get(profile, "imageUrl", "")}
                />
              </div>
              <p className="post-bar__post--blank__helper">Post something...</p>
            </div>
          ) : (
            <div className="post-bar__post post-bar__post--blank">
              {!type && <div className="post-bar__post__arrow"></div>}
              <div className="user-create-block">
                <div className="user-create-block__avatar"></div>
              </div>
              <p className="post-bar__post--blank__helper">Post something...</p>
            </div>
          )}
        </>
      )}
      {type && <div className="create-bg"></div>}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

CreateBar.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
  handleOpen: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, null)(CreateBar)
);
